export default __webpack_public_path__ + "static/media/departmentprofile.c5a0a2b5.jpg";